import {stopPropagation} from '@dvrd/dvr-controls';
import React, {useContext, useRef} from 'react';
import {useNavigate} from 'react-router';
import Vehicle from '../../models/vehicleModel';
import {DISTANCE_ROUTE, VEHICLE_STORAGE_KEY} from '../../util/constants';
import {ActivateHandle} from '../../util/interfaces';
import {saveInStorage} from '../../util/storageUtil';
import {AppContext} from '../context/appContext';
import VehicleDataController from './data/vehicleDataController';
import VehicleSelect from './vehicleSelect';

export default function VehicleSelectController() {
    const context = useContext(AppContext);
    const dataRef = useRef<ActivateHandle>(null);
    const navigate = useNavigate();

    function onSelectVehicle(vehicle: Vehicle) {
        return function () {
            saveInStorage(VEHICLE_STORAGE_KEY, vehicle.id);
            context.onChangeContext({vehicle});
        };
    }

    function onEditVehicle(vehicle: Vehicle) {
        return function (evt: React.MouseEvent) {
            stopPropagation(evt);
            dataRef.current?.activate(vehicle);
        };
    }

    function onClickCreate() {
        dataRef.current?.activate();
    }

    function onClose() {
        navigate(DISTANCE_ROUTE);
    }

    return (
        <>
            <VehicleSelect onSelectVehicle={onSelectVehicle} onEditVehicle={onEditVehicle} onClickCreate={onClickCreate}
                           onClose={onClose}/>
            <VehicleDataController ref={dataRef}/>
        </>
    );
}